import { CheckCircle2, Mail, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: Mail, label: "Secure reset link by email" },
  { icon: ShieldCheck, label: "Security check protects the request" },
  { icon: CheckCircle2, label: "Sign back in when you're ready" },
];

export default function Nd1ForgotPasswordMarketing() {
  return (
    <aside className="nd1-auth-aside nd1-auth-aside--signin" aria-label="Password reset support">
      <div className="nd1-auth-aside__copy">
        <p className="nd1-auth-card__eyebrow">Account recovery</p>
        <h1 className="nd1-auth-aside__title">
          <span className="nd1-ink">Reset securely and</span>
          <span className="nd1-ink-green">get back to JOBUWIN.</span>
        </h1>
        <p className="nd1-auth-aside__lede">
          We send password reset instructions only to the email linked to your account.
        </p>
      </div>
      <ul className="nd1-auth-aside__features">
        {FEATURES.map(({ icon: Icon, label }) => (
          <li key={label}>
            <Icon className="nd1-icon" aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
